module.exports = __webpack_public_path__ + "img/result-reject.6ddd98ad.svg";